/**
 * Custom static styles.
 *
 * ! Avoid adding anything to this export, unless absolutely necessary.
 * ! Rather, refactor these definitions into component-specific styles.
 */
export var staticStyles = [];
//# sourceMappingURL=static-styles.js.map